import { i18n } from "..";

export enum TravelDestinationEnum {
  EUROPE = 'europe',
  WORLD = 'world',
}


export const TravelDestinationEnumLabel = {
  [TravelDestinationEnum.EUROPE]: i18n.t('common.constants.travelDestinations.europe'),
  [TravelDestinationEnum.WORLD]: i18n.t('common.constants.travelDestinations.world'),
}